import api from "../utils/api";
import { ROLE_FEATURES_URL } from "../utils/endpoints";

interface Features {
  code: string;
  name: string;
  description: string;
  level: number;
}

export async function getFeatures(roleLevelId?: number) {
  try {
    const response = await api.get(
      roleLevelId
        ? `${ROLE_FEATURES_URL}?RoleLevelId=${roleLevelId}`
        : ROLE_FEATURES_URL,
    );
    const data: Features[] = response.data.features.map((option: Features) => ({
      code: option.code,
      name: option.name,
      description: option.description,
      level: option.level,
    }));
    return data;
  } catch (error) {
    throw error;
  }
}
